import React, { Component } from 'react';
import Link from 'next/link';
import { Button, Divider, Icon, Input, Tooltip } from 'antd';
import {
    generalStateChange,
    contactAction
} from "../src/store/actions";
import { connect } from "react-redux";
import { validEmail } from "../src/utils/helpers";

const { TextArea } = Input;


class Contact extends Component {
    static async getInitialProps(ctx) {
        return {
            title: 'Rojgari sanjal contact | Contact details of Rojgari sanjal',
            meta_desc: 'Rojgari sanjal is free job portal in nepal our contact details phone 015903073 email info@rojgarisanjal.com.',
            keywords: 'rojgari sanjal contact number, rojgari sanjal address, rojgari sanjal email, modern job portal, employee and employers meeting platform, free job platform,  Post free Vacancy in Nepal,Free job portal in Nepal, job posting site in nepal, best job portal in nepal, no1 job portal in nepal, large job portal in nepal, find employee in nepal, how to post vacancy in Nepal, post job ads in nepal, post vacancy in nepal',
            showFooter: true
        }
    }

    state = {
        search: ''
    };

    render() {
        const { contact, savingContact, contactSuccess } = this.props.app;
        return (<div>
            <div className="tr-breadcrumb bg-image section-before jobs-listing">
                <div className="container">
                    <div className="breadcrumb-info text-center">
                        <h2>CONTACT US</h2>

                        <ul className="job-meta tr-list list-inline">
                            <li>
                                <Link href={'/'}><a href={''}><i className="fas fa-home" />{'Rojgari Sanjal'}</a></Link>
                                &nbsp;&nbsp;<i className="fas fa-chevron-right" /><span
                                    style={{ color: '#ccc' }}>Contact Us</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="job-list-container">
                <div className="container">
                    <div className="row contact_info">
                        <div className="col-4 info_box_c">
                            <i className="fas fa-map-marker-alt" />
                            <p>Baneshwor - 10, Kathmandu</p>
                        </div>
                        <div className="col-4 info_box_c">
                            <i className="fas fa-envelope-open" />
                            <p><a href="mailto:support@rojgarisanjal.com">info@rojgarisanjal.com</a></p>
                        </div>
                        <div className="col-4 info_box_c">
                            <i className="fas fa-phone" />
                            <p>9851316217</p>
                        </div>
                    </div>

                    <div className="contact_form">
                        {!contactSuccess ?
                            <form action="">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="">Your Name</label>
                                            <Input
                                                tabIndex={1}
                                                onChange={(e) => {
                                                    this.props.generalStateChange({
                                                        props: 'contact',
                                                        value: e.target.value,
                                                        deep: 'full_name'
                                                    });
                                                }}
                                                value={contact.full_name}
                                                size="large"
                                                placeholder="Jon Doe"
                                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="">Email</label>
                                            <Input

                                                tabIndex={2}
                                                onChange={(e) => {
                                                    this.props.generalStateChange({
                                                        props: 'contact',
                                                        value: e.target.value,
                                                        deep: 'email'
                                                    });
                                                }}
                                                value={contact.email}
                                                size="large"
                                                placeholder="youremail@example.com"
                                                prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                suffix={
                                                    <Tooltip title="We will use this email to contact you">
                                                        <Icon type="info-circle" style={{ color: 'rgba(0,0,0,.45)' }} />
                                                    </Tooltip>
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="">Phone</label>
                                            <Input

                                                tabIndex={3}
                                                onChange={(e) => {
                                                    if (e.target.value === '' || /\d/.test(e.target.value))
                                                        this.props.generalStateChange({
                                                            props: 'contact',
                                                            value: e.target.value,
                                                            deep: 'phone'
                                                        });
                                                }}
                                                value={contact.phone}
                                                size="large"
                                                placeholder="98########"
                                                prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                suffix={
                                                    <Tooltip title="Incase we need to give you a call">
                                                        <Icon type="info-circle" style={{ color: 'rgba(0,0,0,.45)' }} />
                                                    </Tooltip>
                                                }
                                            />
                                        </div>


                                        <div className="form-group d-none d-md-block">
                                            <Button
                                                disabled={contact.full_name.length < 3 || contact.subject.length < 3 || !contact.email.length || !contact.phone || contact.phone.length < 10 || contact.message.length < 25 || !validEmail(contact.email)}
                                                loading={savingContact}
                                                onClick={this.props.contactAction}
                                                tabIndex={5} block type={'primary'} size={'large'}>Send Message</Button>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="">Subject</label>
                                            <Input
                                                tabIndex={3}
                                                onChange={(e) => {
                                                    // if (e.target.value === '' || /\d/.test(e.target.value))
                                                    this.props.generalStateChange({
                                                        props: 'contact',
                                                        value: e.target.value,
                                                        deep: 'subject'
                                                    });
                                                }}
                                                value={contact.subject}
                                                size="large"
                                                placeholder=""
                                                prefix={<Icon type="highlight" />}

                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="">Message (min 25 character)</label>
                                            <TextArea

                                                tabIndex={4}
                                                onChange={(e) => {
                                                    this.props.generalStateChange({
                                                        props: 'contact',
                                                        value: e.target.value,
                                                        deep: 'message'
                                                    });
                                                }}
                                                value={contact.message}
                                                style={{ height: 172, paddingTop: 20, paddingLeft: 20 }}
                                                placeholder="Your Message"
                                            />
                                        </div>
                                        <div className="form-group d-md-none d-block">
                                            <Button
                                                disabled={contact.full_name.length < 3 || contact.subject.length < 3 || !contact.email.length || !contact.phone || contact.phone.length < 10 || contact.message.length < 25 || !validEmail(contact.email)}
                                                loading={savingContact}
                                                onClick={this.props.contactAction}
                                                tabIndex={5} block type={'primary'} size={'large'}>Send Message</Button>
                                        </div>

                                    </div>

                                </div>
                            </form> : <div className={'contact_success'}>
                                <i className="fas fa-paper-plane" />
                                <h1>Woo hoo</h1>
                                <p>Thank you! Your message was sent successfully. You will soon receive a reply from
                                    us.</p>
                                <br />
                                <br />
                                <p>Support RojgariSanjal</p>
                                <Divider />
                                <Button onClick={() => {
                                    this.props.generalStateChange({ props: 'contactSuccess', value: false })
                                }} size={'large'} type={'primary'}>Send Again</Button>
                            </div>}
                    </div>

                </div>
            </div>

        </div>);
    }

    componentDidMount() {
        const html = document.querySelector('html');
        html.style.height = 'initial';
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
    }
};

export default connect(mapStateToProps, { generalStateChange, contactAction })(Contact);